import { render, staticRenderFns } from "./GrantRegistryProject.vue?vue&type=template&id=182cbd3c&scoped=true&"
import script from "./GrantRegistryProject.vue?vue&type=script&lang=js&"
export * from "./GrantRegistryProject.vue?vue&type=script&lang=js&"
import style0 from "./GrantRegistryProject.vue?vue&type=style&index=0&id=182cbd3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182cbd3c",
  null
  
)

export default component.exports